require('./abc.filter')
require('./ago.filter')
require('./capitalize.filter')
require('./date.filter')
require('./datetime.filter')
require('./decimal.filter')
require('./lowercase.filter')
require('./number.filter')
require('./uppercase.filter')
